"use strict";

module.exports = {
    "footer": {
        "about": "Tentang Yandex",
        "about-url": "//company.yandex.com/",
        "advert": "Iklan",
        "advert-url": "",
        "apps": "Aplikasi seluler",
        "apps-url": "",
        "stat": "Statistik",
        "termsofuse": "Syarat dan Ketentuan",
        "termsofuse-url": ""
    }
};